import { matchSorter } from 'match-sorter';

export function fuzzyTextFilterFn(rows: any, id: any, filterValue: any) {
  return matchSorter(rows, filterValue, {
    keys: [(row: any) => row.values[id]],
  });
}

// Let the table remove the filter if the string is empty
fuzzyTextFilterFn.autoRemove = (val: any) => !val;

export const getPageCount = (count: number, pageSize: number) => {
  return Math.ceil(count / pageSize);
};
